// TODO: Not a component, should be moved
import React, { useReducer, useContext, createContext } from 'react';
import PropTypes from 'prop-types';

const StateContext = createContext();

const StateProvider = ({ reducer, initialState, children }) => (
    <StateContext.Provider value={useReducer(reducer, initialState)}>{children}</StateContext.Provider>
);

export const useContextState = () => {
    const context = useContext(StateContext);
    if (!context) {
        return [];
    }
    return context;
};

StateProvider.propTypes = {
    reducer: PropTypes.func,
    initialState: PropTypes.object,
    children: PropTypes.node,
};

export default StateProvider;
